import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../i18n';
import { BrandMark } from './BrandMark';
import { DevTokenForm } from './DevTokenForm';
import { MagicLinkSignIn } from './MagicLinkSignIn';
import { supabase } from '../../lib/supabase';

export function LoginAuthPanel() {
  const { t } = useTranslation('auth');
  const year = formatDateTime(new Date(), { year: 'numeric' });
  return (
    <section
      className="relative flex min-h-screen flex-col px-6 py-10 sm:px-10 lg:min-h-full lg:px-14 lg:py-12"
      style={{ backgroundColor: '#F7F5F2' }}
    >
      <div className="mx-auto flex w-full max-w-[420px] flex-1 flex-col justify-center">
        <BrandMark className="mx-auto h-14 w-14" />

        <div className="mt-7">
          {supabase ? (
            <MagicLinkSignIn />
          ) : (
            <>
              <div className="text-center">
                <h2 className="text-[2rem] font-semibold tracking-[-0.03em] text-[#12141a]">
                  {t('signIn.title')}
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-[#12141a]/55">
                  {t('signIn.subtitle')}
                </p>
              </div>
              <div className="mt-10">
                <DevTokenForm />
              </div>
            </>
          )}
        </div>
      </div>

      <footer className="mx-auto mt-10 flex w-full max-w-[420px] flex-col gap-3 text-xs text-[#12141a]/40 sm:mt-8 sm:flex-row sm:items-center sm:justify-between">
        <nav className="flex gap-4">
          <a href="#" className="transition hover:text-[#12141a]/70">
            {t('footer.privacy')}
          </a>
          <a href="#" className="transition hover:text-[#12141a]/70">
            {t('footer.terms')}
          </a>
          <a href="#" className="transition hover:text-[#12141a]/70">
            {t('footer.support')}
          </a>
        </nav>
        <p>{t('footer.copyright', { year })}</p>
      </footer>
    </section>
  );
}
